// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e55bda2c","444":"16590498","453":"e62b6b75"}[chunkId] + ".chunk.js";
};